import React, { memo, useEffect, useState } from "react";
import { cdnImg } from "../Utils/cdnImage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { isMobile } from "react-device-detect";
import HomeSliderCasinoList from "./HomeSliderCasinoList";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
function SlickAppendDots(dots) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "6px",
        marginTop: "10px",
      }}
    >
      {dots.map((dot, i) => (
        <div
          key={i}
          className={`custom-dot ${dot.props.className.includes("slick-active") ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

const HOME_CAROUSEL_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  appendDots: SlickAppendDots,
  customPaging: () => <div />,
  autoplay: true,
  cssEase: "linear",
  arrows: false,
};

const HomeCarousel = () => {
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (loader) {
      let timer = setTimeout(() => {
        setLoader(false);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [loader]);
  const [bannerData, setBannerData] = useState([]);
  const getData = async () => {
    const { status, data } = await apiPost(apiPath.getBanner, {
      type: "home_top",
    });
    if (status == 200) {
      if (data?.success) {
        setBannerData(data?.results?.banners);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <div
        className={
          isMobile
            ? "default-carousel ng-star-inserted"
            : "top-banner-wrapper custom-banner-wrapper custom-banner-wrapper--shrink unit-1 ng-star-inserted"
        }
      >
        <div
          className={
            isMobile ? "owl-stage-outer ng-star-inserted" : "banner-v1"
          }
        >
          {" "}
          <style>{`
        .custom-dot {
          width: 8px;
          height: 6px;
          border-radius: 4px;
          background: rgba(255, 255, 255, 0.4);
          cursor: pointer;
          transition: width 0.3s ease, background 0.3s ease;
        }
        .custom-dot.active {
          width: 20px;
          background: #ffb80c;
        }
      `}</style>
          <Slider className="banner-swiper" {...HOME_CAROUSEL_SETTINGS}>
            {(bannerData?.length > 0
              ? bannerData
              : isMobile
                ? array
                : arrayDesktop
            )?.map((item) => {
              return (
                <div className="owl-item ng-tns-c66-2 ng-trigger ng-trigger-autoHeight ng-star-inserted cloned">
                  <div className="slide ng-star-inserted">
                    <a href="#" className="ng-star-inserted">
                      <img
                        style={{
                          height: isMobile ? "110px" : "auto",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        alt="dragon tiger_Exchmarket: Best Online Sports Betting Sites in India, 2024"
                        src={
                          bannerData?.length > 0
                            ? process.env.REACT_APP_API_BASE_URL +
                              item?.banner_path
                            : item
                        }
                      />
                    </a>
                  </div>
                </div>
              );
            })}{" "}
          </Slider>
        </div>
      </div>
      <HomeSliderCasinoList />
    </>
  );
};

export default memo(HomeCarousel);

let array = [
  "/assets/Other/banner1.jpeg",
  "/assets/Other/banner2.jpeg",
  "/assets/Other/banner3.jpeg",
];

let arrayDesktop = [
  "/assets/Other/banner1.jpeg",
  "/assets/Other/banner2.jpeg",
  "/assets/Other/banner3.jpeg",
];
